// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';

import store from './store/index'
import router from './router';
import qs from 'qs'
// 全局组件
import './components/common/index.js';
// 全局指令
import './js/app/directive/fdDirective.js';
// 全局过滤器
import './js/app/filter/fdFilter.js';
// 全局消息
import './js/app/message/fdMessage.js';
// 全局配置
import './js/config.js';
// 全局方法类
import FdGlobal from './js/app/common/fdGlobal.js';
// 引入 Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './css/fonts.css';


import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);

Vue.use(ElementUI);
// 开始时间
const startTime = new Date().getTime();
// 全局对象
window.fdGlobal = new FdGlobal();
Vue.config.productionTip = false;
window.fdGlobal.performance.start(startTime);
window.fdGlobal.performance.execute('【app start】:');

// swiper切换


/* eslint-disable no-new */
// import websdk from "easemob-websdk"
// import webimconfig from './webim.config'
// let WebIM = window.WebIM = websdk;
// WebIM.config = webimconfig;
// // 环信实例
// var conn = WebIM.conn = new WebIM.connection({
//     appKey: WebIM.config.appkey,
//     isHttpDNS: WebIM.config.isHttpDNS,
//     isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
//     https: WebIM.config.https,
//     url: WebIM.config.xmppURL,
//     apiUrl: WebIM.config.apiURL,
//     isAutoLogin: true,
//     heartBeatWait: WebIM.config.heartBeatWait,
//     autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
//     autoReconnectInterval: WebIM.config.autoReconnectInterval,
//     isStropheLog: WebIM.config.isStropheLog,
//     delivery: WebIM.config.delivery
// })
// var optionsIm = {
//     apiUrl: WebIM.config.apiURL,
//     user: localStorage.hxloginName_qy, //换成自己申请的账号就行，密码也需要换  
//     pwd: window.serverConfig.baseName,
//     appKey: WebIM.config.appkey,
//     success: function (re) {
//         console.log('登陆成功')
//     },
//     error: function (err) {
//         console.log(err)
//     }
// }
// Vue.prototype.$WebIM = WebIM;
// Vue.prototype.$imconn = conn
// Vue.prototype.$imoption = optionsIm;
router.beforeEach((to, from, next) => {
    //根据字段判断是否路由过滤
    if (to.name != 'login') {
        // let param = {
        //     token : localStorage.token_qy || ''
        // }
        // window.fdGlobal.ajax({
        //     method: 'POST',
        //     url: window.fdConfig.url.login('checkToken'),
        //     // URL参数
        //     // 必须是一个纯对象或者 URL参数对象
        //     headers: { 'content-type': 'application/x-www-form-urlencoded' },
        //     data: qs.stringify(param),
        //     //params: '',
        //     // 默认值是json
        //     responseType: 'json'
        // }).then((data) => {
        //     console.log('checkToken',data)
        //     if(data.data.code == 1){
        //         next()
        //     }else{
        //         next({
        //             path: '/login',
        //         });
        //     }
        // }, (data) => {
        //     next({
        //         path: '/login',
        //     });
        // });
        next()
    } else {
        next()
    }

});

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    beforeCreate() {
        // 开始时间
        this.beforeCreateTime = window.fdGlobal.performance.getCurrentTime();
    },
    created() {
        window.fdGlobal.performance.execute('【app created】:', this.beforeCreateTime);
        window.fdGlobal.performance.execute('【app created】:');
    },
    mounted() {
        window.fdGlobal.performance.execute('【app mounted】:', this.beforeCreateTime);
        window.fdGlobal.performance.execute('【app mounted】:');
    }
});


// WEBPACK FOOTER //
// ./src/main.js